module.exports = __webpack_public_path__ + "static/img/Wood.0dcd8cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art/compressed/misc_3d/Wood.jpg
// module id = uBcZ
// module chunks = 1